module.exports = __webpack_public_path__ + "static/media/  (5).271fd186.jpg";